import styles from "./style.module.css";
import {useTranslation} from "react-i18next";
import api from "../../../utils/axios/api";
import InvalidVoucher from "../../../assets/invalidVoucher.svg";
import ValidVoucher from "../../../assets/validVoucher.svg";

export interface CupomProps {
  name: string;
  discount: number;
  valid: boolean;
}

interface AplicarCupomProps {
  setVoucher: (cupom: CupomProps) => void;
  voucher: CupomProps;
}

const AplicarCupom = ({ setVoucher, voucher }: AplicarCupomProps) => {
  const { t } = useTranslation();

  //TODO: preciso verificar se o voucher é valido e recuperar o valor de desconto dele
  const handleApply = async () => {
    // Verificar a existencia e recuperar o valor se existir
    console.log("antes da chamada a admin/vouchers");
    console.log(voucher.name);
    try {
      const voucherResponse = await api.get(
        `/admin/vouchers/name/${voucher.name}`
      );
      console.log(voucher.valid);
      setVoucher({
        name: voucherResponse.data.name,
        discount: voucherResponse.data.discount,
        valid: true,
      });
      console.log(voucher);
    } catch (error: any) {
      setVoucher({ name: "", discount: 0, valid: false });
      console.log(error.response.data);
      console.error(error);
    }
  };

  return (
    <div className={styles.cupom_container}>
      <div className={styles.input_container}>
        <input
          className={styles.inserir}
          type="text"
          placeholder={t("cupom.digitar")}
          value={voucher.name}
          onChange={(e) =>
            setVoucher({ discount: 0, valid: false, name: e.target.value })
          }
        />

        {voucher.valid && <img src={ValidVoucher} width={16} height={16}/>}
        {!voucher.valid && <img src={InvalidVoucher} width={16} height={16}/>}
      </div>
      <button type="button" className={styles.botao} onClick={handleApply}>
        {t("cupom.aplicar")}
      </button>
    </div>
  );
};

export default AplicarCupom;
